export type PresentationRefSlideLinkState =
  | 'ref_and_slides'
  | 'ref_no_slides'
  | 'slides_no_ref';

export function resolvePresentationRefSlideLinkState(params: {
  hasRef: boolean;
  slidePageCount: number;
}): PresentationRefSlideLinkState | null {
  const hasSlides = params.slidePageCount > 0;
  if (params.hasRef && hasSlides) return 'ref_and_slides';
  if (params.hasRef && !hasSlides) return 'ref_no_slides';
  if (!params.hasRef && hasSlides) return 'slides_no_ref';
  return null;
}

export function presentationRefSlideLinkStateLabel(state: PresentationRefSlideLinkState | null | undefined): string {
  switch (state) {
    case 'ref_and_slides':
      return 'ref + 슬라이드';
    case 'ref_no_slides':
      return 'ref만 (슬라이드 없음)';
    case 'slides_no_ref':
      return '슬라이드만 (ref 없음)';
    default:
      return '—';
  }
}

export function sumSlidePageCountForOwners(
  statsMap: ReadonlyMap<string, { pageCount: number }>,
  ownerKeys: string[]
): number {
  let total = 0;
  ownerKeys.forEach((key) => {
    total += statsMap.get(key)?.pageCount ?? 0;
  });
  return total;
}
